import { ROOM_PROPERTIES } from '@/interfaces/room.interface'
import { getRequestGateway } from '@/services/api.service'

/* Returning room information (per floor) as GeoJSON data */
export async function getSpacev1(spaceId) {
  const response = await getRequestGateway<ROOM_PROPERTIES>(`core/v1/spaces/${spaceId}`, null)
  return response.data
}

/* Returning room information (per level) as GeoJSON data */
export async function getRoomsForSelectedLevelv1(constructionId, levelId) {
  try {
    const response = await getRoomsForLevelv1(constructionId, levelId)
    const responseGeojson = await getRequestGateway(
      `core/v1/spaces/geojson?construction=${constructionId}&level=${levelId}`
    )
    return {
      type: 'geojson',
      data: {
        id: 'rooms',
        type: 'FeatureCollection',
        features: response.map((room) => {
          const geometry = responseGeojson.data.find((feature) => feature.id === room.id)?.geometry
          return {
            type: 'Feature',
            id: room.id,
            geometry,
            properties: room
          }
        })
      }
    }
  } catch (e) {
    console.error(e)
    throw new Error('Could not fetch rooms', { cause: e })
  }
}

export async function getRoomsForLevelv1(constructionId, levelId) {
  try {
    const response = await getRequestGateway(
      `core/v1/spaces?construction=${constructionId}&level=${levelId}`
    )
    return response?.data
  } catch (e) {
    console.error(e)
    throw new Error('Could not fetch rooms for level', { cause: e })
  }
}
